import React from "react";

const ShippingPolicy = () => {
  return (
    <div className="bg-[#fcf3f8] text-[#4b2b1b]">
      <div className="container mx-auto px-6 py-12 max-w-4xl">

        <h1 className="text-3xl font-bold mb-8 text-center">
          Shipping Policy
        </h1>

        <div className="space-y-4 text-lg leading-relaxed font-medium">

          <p>• Once your order is placed, our team dispatches it within 3 days.</p>

          <p>• When the parcel is dispatched, shipping takes approximately 7–10 business days.</p>

          <p>• You will receive an email when your order is confirmed and a tracking ID once your order is shipped.</p>

          <p>• In case a damaged product has reached you, please get in touch with us within 24 hours of delivery.</p>

          <p>• Orders are processed Monday to Saturday (excluding Public Holidays).</p>

          <p>• Orders placed after 5 PM will be processed on the next working day.</p>

          <div>
            <p>• Please ensure your shipping address and contact number are correct. Delivery may fail if:</p>
            <ul className="list-disc pl-6 mt-2">
              <li>The address is incorrect or incomplete</li>
              <li>The customer is unavailable</li>
              <li>The phone number is unreachable</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default ShippingPolicy;
